import React from 'react';
import {DropzoneAreaBase} from "material-ui-dropzone";
import {MasterOfActsAPI} from "../../../../api/api";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {getHandbooks} from "../../../../redux/reducers/handbook-reducer";
import {useSelector} from "react-redux";
import {getProfile} from "../../../../redux/reducers/user-profile-reducer";
import {downloadViolationFile, getActs} from "../../../../redux/reducers/act-reducer";


import {downloadFile} from "../../../../utils/files";

const useStyles = makeStyles(() => (
    {
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))


export const AnalysisUpload = ({ name, label, value, disabled}) => {
    const classes = useStyles()
    const onAddFile = async (newFiles) => {
        let acceptedFiles = [];
        for (const newFile of newFiles) {
          const response = await MasterOfActsAPI.uploadContractorRemovalFiles(
            newFile.file.name,
            newFile.file.type,
            1,
            newFile.file,
            29
          );
          if (response.status === 201) {
            downloadFile(MasterOfActsAPI.downloadAnalysisFile())                
            acceptedFiles = [...acceptedFiles, {file: {name: newFile.file.name}, id: response.data.id}]
          }
        } 
        
      };
    
    const onDownloadFile = async (event) => {
        const filename = event.target.outerText;
        
      };
    return <DropzoneAreaBase
        acceptedFiles={[

          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]}

        fileObjects={value}
        dropzoneText={label}
        onAdd={onAddFile}
        onDelete={null}
        filesLimit={9}
        getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
        getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
        getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
        getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
        showPreviews={true}
        showPreviewsInDropzone={false}
        useChipsForPreview
        previewGridProps={{container: {spacing: 1, direction: 'row'}}}
        previewChipProps={
            {
                classes: {
                    root: classes.previewChip
                },
                onClick: onDownloadFile
            }}
        previewText="Загруженные файлы"
        dropzoneProps={{disabled: disabled}}
    />
}